import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { deleteCustomFilter } from 'modules/_common/api';

export const useMutationDeleteCustomFilter = () => {
  const { t } = useTranslation();

  const { successToast, errorToast } = useCustomToast();
  const queryClient = useQueryClient();

  return useMutation(deleteCustomFilter, {
    onSuccess: () => {
      successToast(t('You have successfully deleted the filter'));
      queryClient.refetchQueries(QUERY_KEYS.RESERVATION_NEW_CUSTOM_FILTER);
      queryClient.refetchQueries(QUERY_KEYS.RENTALS_PROPERTIES);
      queryClient.refetchQueries(QUERY_KEYS.EVISITOR_GUESTS);
    },
    onError: () => errorToast(),
  });
};
